var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRoleDefault = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u89D2\u8272\u9ED8\u8BA4\u6001") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u89D2\\u8272\\u9ED8\\u8BA4\\u6001"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    fillOpacity: 0.4,
    fill: "#52C41A",
    cx: 8.5,
    cy: 5.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,6.54373191 C0,2.92981841 2.92981841,0 6.544346,0 L7.45626809,0 C11.0701816,0 14,2.92981841 14,6.54373191 L14,11.8599 C14,12.5382039 13.450126,13.0880779 12.7718221,13.0880779 L12.0177209,13.0880779 C11.6785689,13.0880779 11.4036319,12.8131409 11.4036319,12.4739889 C11.4036319,12.134837 11.6785689,11.8599 12.0177209,11.8599 L12.7718221,11.8599 L12.7718221,6.54373191 C12.7718221,3.6080325 10.3919675,1.22817791 7.45626809,1.22817791 L6.544346,1.22817791 C3.60847701,1.22817791 1.22848495,3.60816997 1.22848495,6.54403895 C1.22848495,9.47990794 3.60847701,11.8599 6.544346,11.8599 L9.73699447,11.8599 C10.0761464,11.8599 10.3510834,12.134837 10.3510834,12.4739889 C10.3510834,12.8131409 10.0761464,13.0880779 9.73699447,13.0880779 L6.54373191,13.0880779 C2.92981841,13.0880779 0,10.1582595 0,6.54373191 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#041B0F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.80673743,6.17080649 C3.80673743,5.87278769 4.0483294,5.63119572 4.3463482,5.63119572 C4.644367,5.63119572 4.88595898,5.87278769 4.88595898,6.17080649 L4.88595898,7.25002803 C4.88595898,7.54804683 4.644367,7.78963881 4.3463482,7.78963881 C4.0483294,7.78963881 3.80673743,7.54804683 3.80673743,7.25002803 L3.80673743,6.17080649 Z M8.20211889,6.17080649 C8.20211889,5.87278769 8.44371086,5.63119572 8.74172966,5.63119572 C9.03974846,5.63119572 9.28134043,5.87278769 9.28134043,6.17080649 L9.28134043,7.25002803 C9.28134043,7.54804683 9.03974846,7.78963881 8.74172966,7.78963881 C8.44371086,7.78963881 8.20211889,7.54804683 8.20211889,7.25002803 L8.20211889,6.17080649 Z",
    id: "\\u5F62\\u72B6",
    fill: "#041B0F",
    fillRule: "nonzero"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRoleDefault);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/role_default.de590e1693fadf9a26e021bcd3d615ad.svg";